import Splide from "@splidejs/splide";

export const realSlider = () => {
  const slider = new Splide(".js-real-slider", {
    fixedWidth: "20.6rem",
    pagination: false,
    gap: "1rem",
    perMove: 1,
    flickMaxPages: 1,
    flickPower: 120,
    padding: {
      left: "0.8rem",
      right: "0.8rem",
    },
  });

  // ドラッグ操作のときだけ「1回の操作で1枚」へ矯正（矢印クリックには絶対に干渉しない）
  let isDragging = false;
  let dragStartIndex = 0;

  slider.on("drag", () => {
    if (!isDragging) {
      isDragging = true;
      dragStartIndex = slider.index;
    }
  });

  slider.on("dragged", () => {
    // moved が後から飛ぶことがあるので、1tick だけドラッグ扱いを残す
    requestAnimationFrame(() => {
      isDragging = false;
    });
  });

  slider.on("moved", (newIndex) => {
    if (!isDragging) return;
    const diff = Math.abs(newIndex - dragStartIndex);
    if (diff <= 1) return;
    const direction = newIndex > dragStartIndex ? 1 : -1;
    slider.go(dragStartIndex + direction);
  });

  slider.mount();
};
